import { FC } from 'react';

import SwapInfo from 'shared/components/SwapInfo';
import { CUSTOM_CHAINS } from 'shared/constants/custom-chain.constants';
import { RISK_TYPE } from 'shared/constants/risks.constants';
import { Web3ContractEntity } from 'shared/interfaces/analyze.interfaces';
import { TraceWithRisk } from 'shared/interfaces/fetch.interfaces';

import { ProtocolRisks } from './interfaces';
import styles from './styles.module.scss';
import AdditionalInfo from '../../components/AdditionalInfo';
import Report from '../../components/Report';
import CustomChainMessage from '../components/CustomChainMessage';
import Note from '../components/Note';
import { TransactionDetailsData, TransactionGasDetails } from '../interfaces';

interface Props {
  transactionDetails: TransactionDetailsData;
  risks: ProtocolRisks[];
  handleTokenSelect: (tokenAddress: string, type: Web3ContractEntity.type) => void;
  gasDetails: TransactionGasDetails | null;
  risk: RISK_TYPE;
  trace: TraceWithRisk[];
  chain?: CUSTOM_CHAINS;
  isLightMode?: boolean;
}

const ScanningResult: FC<Props> = ({
  risks, handleTokenSelect, transactionDetails, gasDetails, risk, trace, chain, isLightMode,
}) => {

  const dangerMessages = [
    ...transactionDetails.dangerMessages || [],
  ];

  const hasSwapDetails = transactionDetails.swap?.income?.length > 0 || transactionDetails.swap?.loss?.length > 0;

  return (
    <>
      <div className={styles.wrap}>
        {chain && <CustomChainMessage chain={chain} />}
        <Report
          risk={risk}
          risks={risks}
          handleContractSelect={handleTokenSelect}
          trace={trace}
          detects={dangerMessages}
          chain={chain}
          isLightMode={isLightMode}
          label="transaction"
        />
        {hasSwapDetails && (
          <div className={styles.block}>
            <SwapInfo data={transactionDetails.swap} isLightMode={isLightMode} />
          </div>
        )}
        {/* <TotalRisks risks={risks} handleTokenSelect={handleTokenSelect} /> */}
        {!isLightMode && <AdditionalInfo gasDetails={gasDetails} dexPairs={transactionDetails.swap?.dexPairs || null} />}
        <Note />
      </div>
    </>
  );
};

export default ScanningResult;
